import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction, toJS} from "mobx";
import PropTypes from "prop-types";
import {ComponentContext} from "../../contexts";
import {input} from "../../utils/linker";

function FieldTypeSelector(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compContext = useContext(ComponentContext);

  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  const getOptions = () => {
    const arr=[<option key="blank" value=""></option>];
    console.log("compContext.field_types", toJS(compContext.field_types));
    if(compContext.field_types.inited) {
      for( let i in compContext.field_types.data) {
        if(
          (compContext.cur_table_view.type === "multi" && compContext.field_types.data[i].multi) ||
          (compContext.cur_table_view.type !== "multi" && !compContext.field_types.data[i].multi)
        ) {
          arr.push(<option key={i} value={i}>{compContext.field_types.data[i].name}</option>);
        }
      }
      return arr;
    }
    return null;
  };


  return (
    <div>
      <span className="select w100">
        <select {...input(props.linker, "value")}>
          {getOptions()}
        </select>
      </span>
    </div>
  )
};

FieldTypeSelector.defaultProps = {};

FieldTypeSelector.propTypes = {}

export default observer(FieldTypeSelector);
